import apiService from '../Api'
import { IContestEvaluationCriterion, ICriteriaSyncPayload } from './interfaces'

interface ICriteriaResponseRaw {
  total: number
  data: (Omit<IContestEvaluationCriterion, 'weight'> & { weight: number | string })[]
}

// Laravel casts the decimal weight to a string ("30.00"); normalize to number.
function normalize(response: ICriteriaResponseRaw): { total: number; data: IContestEvaluationCriterion[] } {
  return {
    total: response.total,
    data: response.data.map((criterion) => ({ ...criterion, weight: Number(criterion.weight) }))
  }
}

export default class ContestEvaluationCriteriaService {
  async list(contestId: number | string): Promise<{ total: number; data: IContestEvaluationCriterion[] }> {
    return apiService.get(`/contests/${contestId}/evaluation-criteria`).then((response) => normalize(response.data))
  }

  async sync(
    contestId: number | string,
    payload: ICriteriaSyncPayload
  ): Promise<{ total: number; data: IContestEvaluationCriterion[] }> {
    return apiService
      .put(`/contests/${contestId}/evaluation-criteria`, payload)
      .then((response) => normalize(response.data))
  }
}
